module.exports = __webpack_public_path__ + "img/multi.9ebe9c35.png";